import React from "react";
import "../css/productvisual.scss";

function ProductVisual({ product, compact = false }) {
  return (
    <figure
      className={`product-visual ${compact ? "product-visual--compact" : ""}`}
    >
      <img
        src={product.image}
        alt={`${product.name}, AI-generated product visual`}
        loading="lazy"
        decoding="async"
      />
    </figure>
  );
}

export default ProductVisual;
